import React from "react";
import gettext from "../../shared/utils/gettext";
import cropr from "../../shared/utils/cropr";
import NavLink from "./NavLink";
import Aside from "./Aside";
import { useForceUpdateOnCroprEvent } from "./hooks";
import SubNav from "./SubNav";
import Icon from "../../shared/icons/Icon";

const AsideGrower = () => {
  const { permissions, features } = useForceUpdateOnCroprEvent("init");
  if (!(permissions && features)) return null;
  return (
    <Aside showLogo={!cropr.necBrand}>
      <NavLink
        title={gettext("Dashboard")}
        to={[cropr.necAnalysisAppGid ? "/apps/nec-adv/dashboard/#" : "/cropr/dashboard/#"]}
        exact
        show
      >
        <Icon icon={"dashboard"} size={"fa-lg"} />
        <span>{gettext("Dashboard")}</span>
      </NavLink>
      <NavLink
        title={gettext("Record")}
        to={["/cropr/record/record/"]}
        show={permissions.crop_rec.read}
      >
        <Icon icon={"edit"} size={"fa-lg"} />
        <span>{gettext("Record")}</span>
      </NavLink>
      <NavLink
        title={gettext("Map - Draw")}
        to={["/cropr/farm/plan/", "/integration/extern/"]}
        show={permissions.crop_f.read || permissions.parcel.read}
      >
        <Icon icon={"map"} size={"fa-lg"} />
        <span>{gettext("Map - Draw")}</span>
      </NavLink>
      <NavLink
        title={gettext("Disease")}
        to={["/dss/disease/"]}
        show={features.dacom_online_disease || features.dacom_online_disease_contract}
      >
        <i className="far icn_disease fa-lg" />
        <span>{gettext("Disease")}</span>
      </NavLink>
      <NavLink
        title={gettext("Irrigation")}
        to={["/apps/dacom_online/sensor_overview/page/"]}
        show={features.irrigation || features.sensetion || features.shared_sensors}
      >
        <Icon icon={"irrigation"} size={"fa-lg"} />
        <span>{gettext("Irrigation")}</span>
      </NavLink>
      <NavLink title={gettext("Insects")} to={["/dss/insects/"]} show={features.insect}>
        <Icon icon={"insects"} size={"fa-lg"} />
        <span>{gettext("Insects")}</span>
      </NavLink>
      <NavLink
        title={gettext("Cloudfarm")}
        to={["/apps/cloudfarm/"]}
        show={features.cloudfarm || features.cloudfarm_contract}
      >
        <Icon icon={"cloudfarm"} size={"fa-lg"} />
        <span>{gettext("Cloudfarm")}</span>
      </NavLink>
      <SubNav
        items={[
          [
            ["/apps/dacom_online/weather/page/"],
            gettext("Weather forecast"),
            Boolean(features.weather_forecast),
          ],
          [
            ["/apps/dacom_online/weather_data/page/"],
            gettext("Weather data"),
            Boolean(features.dacom_online_weather),
          ],
        ]}
        title={gettext("Weather")}
        icon={"weather"}
      />
      <SubNav
        items={[
          [
            ["/cropr/record/record_table/"],
            gettext("Records"),
            permissions.crop_rec.read && cropr.getConfig("experiments", "record_table", true),
          ],
          [["/cropr/dashboard/#cropfield/"], gettext("Cropfields"), permissions.crop_f.read],
          [["/cropr/dashboard/#npk_balance/"], gettext("NPK Balance"), permissions.crop_f.read],
          [
            [
              "/cropr/dashboard/#fertilizer/",
              "/cropr/dashboard/#chemical/",
              "/cropr/dashboard/#other/",
              "cropr/dashboard/#yield/",
              "/cropr/dashboard/#seedling/",
            ],
            gettext("Stock"),
            permissions.barn.read,
          ],
          [["/cropr/dashboard/#soil/"], gettext("Soil researches"), permissions.parcel.read],
          [
            ["/cropr/dashboard/#parcel/"],
            gettext("Parcel"),
            permissions.parcel.read,
            false,
            "menu",
            "parcel",
          ],
          [["/apps/admissions/"], gettext("Admissions"), features.admissions],
          [
            ["/cropr/dashboard/#financial/"],
            gettext("Financial"),
            permissions.isOwner && features.report,
          ],
          [
            ["/cropr/dashboard/#reports/"],
            gettext("Reports"),
            features.report,
            false,
            "menu",
            "reports",
          ],
          [
            ["/cropr/settings/image_gallery/"],
            gettext("Gallery"),
            permissions.staff || permissions.isOwner,
          ],
        ]}
        title={gettext("Analysis")}
        icon={"chart-details"}
      />
      <SubNav
        items={[
          [["/cropr/settings/import_export/"], gettext("Import-export"), true],
          [["/cropr/settings/plans/"], gettext("Plan"), permissions.staff || permissions.isOwner],
          [
            ["/cropr/settings/farm_contacts/"],
            gettext("Relations"),
            permissions.staff || permissions.isOwner,
          ],
          [["/cropr/farm/contracts/"], gettext("Contracts"), permissions.crop_f.read],
          [["/supplier/"], gettext("Suppliers"), permissions.barn.read],
          [
            ["/apps/dacom_online/products/sharing/"],
            gettext("Sensors"),
            features.irrigation || features.sensetion || features.shared_sensors,
          ],
          [
            ["/cropr/machines/"],
            gettext("Machines"),
            features.machines && permissions.machine.read,
          ],
          [
            ["/cropr/settings/certificates/"],
            gettext("Certificates"),
            permissions.staff || permissions.isOwner,
          ],
          [
            [
              "/cropr/settings/farm/",
              "/cropr/settings/",
              "/archive/",
              "subscription/my_subscriptions",
            ],
            gettext("Farm settings"),
            true,
          ],
        ]}
        title={gettext("My farm")}
        icon={"farm"}
      />
    </Aside>
  );
};

export default AsideGrower;
